var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import moment from "moment";
import authentication from "@irati/auth";
import client from "@irati/utils/services/apollo";
import { mutation as createReportMutation } from "@irati/insights/apollo/mutation/report/create";
import ReportQuery from "@irati/insights/apollo/query/report/get";
import { REPORT_STATUSES } from "@irati-web/insights/src/utils/constants/report";
import Link from "@irati/ui/src/Link";
import Flex from "@irati/ui/src/Flex";
import ErrorText from "@irati/ui/src/ErrorText";
import Button from "@irati/ui/src/Button";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { FormattedMessage } from "@irati/utils/lang";
import { hangPromise } from "@irati/utils/promise";
var EXPORT_TYPE = "csv";
var POLL_INTERVAL = 2000;
var DownloadReport = /** @class */ (function (_super) {
    __extends(DownloadReport, _super);
    function DownloadReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: null,
            uuid: null
        };
        _this.handleClick = function () {
            var _a = _this.props, reportType = _a.reportType, to = _a.to, from = _a.from, userUuids = _a.userUuids, orderByAmountDesc = _a.orderByAmountDesc, amount = _a.amount;
            var params = {
                tenantUuid: authentication.userTenant().uuid,
                reportType: reportType,
                exportType: EXPORT_TYPE,
                currency: authentication.defaultUserCurrency(),
                from: from || "1970-01-01T00:00:00Z",
                to: to ||
                    moment()
                        .add(1, "day")
                        .format(),
                userUuids: userUuids || [],
                orderByAmountDesc: orderByAmountDesc,
                amountFilter: amount
            };
            _this.setState({ uuid: null });
            var load = client.mutate({ mutation: createReportMutation, variables: { params: params } }).then(function (data) {
                _this.setState({ uuid: data.data.createReport.uuid });
            });
            _this.setState({ load: load });
        };
        return _this;
    }
    DownloadReport.prototype.render = function () {
        var _a = this.state, load = _a.load, uuid = _a.uuid;
        return (React.createElement(Flex, { direction: "column", justifyContent: "space-between" },
            React.createElement(Button, { tertiary: true, marginBottom: uuid ? 2 : 0, onClick: this.handleClick, load: load },
                React.createElement(Icon, { icon: IconTypes.generateReport, marginRight: true }),
                React.createElement(FormattedMessage, { id: "admin.reportingV2.wallet.generateReport" })),
            uuid && (React.createElement(ReportQuery, { key: uuid, variables: { uuid: uuid }, pollInterval: POLL_INTERVAL }, function (_a) {
                var report = _a.report, stopPolling = _a.stopPolling;
                var status = report.status;
                if (status === REPORT_STATUSES.failed) {
                    stopPolling();
                    return (React.createElement(ErrorText, null,
                        React.createElement(FormattedMessage, { id: "admin.reportingV2.wallet.errorReport" })));
                }
                if (status === REPORT_STATUSES.complete) {
                    stopPolling();
                    return (React.createElement(Link, { href: report.resultFileUrl },
                        React.createElement(Icon, { icon: IconTypes.downloadReport, marginRight: true }),
                        React.createElement(FormattedMessage, { id: "admin.reportingV2.wallet.downloadReport" })));
                }
                return React.createElement(Button, { tertiary: true, load: hangPromise() });
            }))));
    };
    return DownloadReport;
}(Component));
export default DownloadReport;
